export default __webpack_public_path__ + "static/media/search_instititu.f5146d67.svg";